import { AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';

export function atLeastOneCheckedValidator(group: FormGroup): ValidationErrors | null {
  const cgpaChecked = group.get('CGPACheck')?.value;
  const percentageChecked = group.get('PercentageCheck')?.value;

  // Check if neither checkbox is checked
  if (!cgpaChecked && !percentageChecked) {
    return { atLeastOneChecked: 'Either CGPA or Percentage must be selected' };
  }
  return null; // No error
}
